module.exports = __webpack_public_path__ + "img/client_2.6162ecc7.png";